import { GroupUsers } from '../access-profile/list-group-users'
import { axios, Response } from '../index'

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
  DONT_WANT_TO_TELL = 'DONT_WANT_TO_TELL'
}

export type PersonaProfileType = {
  id?: string
  appUserId?: number
  avatarName: string
  firstName: string
  lastName: string
  gender: Gender
  cpfOrPassport: string
  email: string
  zipCode: string
  address: string
  houseNumber: string
  complement: string
  city: string
  state: string
  countryCode: string
  ddd: string
  telephoneNumber: string
  avatar: string
  accessProfiles: GroupUsers[]
  login: string
}

const getPersonaProfile = (personaId: string): Response<PersonaProfileType> => {
  return axios.get(`/v1/profiles-personas/${personaId}`)
}

export default getPersonaProfile
